import { type FC } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import copy from "copy-to-clipboard";
import CopyIcon from "@mui/icons-material/FileCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export interface ShareUrlProps {
  url?: string | null;
  label?: string;
  copiedMessage?: string;
}

export const ShareUrl: FC<ShareUrlProps> = ({ url, label, copiedMessage }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = (url: string) => {
    copy(url);
    enqueueSnackbar(
      copiedMessage ??
        t("shared.shareUrl.copied", { defaultValue: "Ссылка скопирована" }),
      { variant: "success" }
    );
  };

  if (!url) return null;

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid size={12}>
        <TextField
          fullWidth
          value={url}
          label={
            label ?? t("shared.shareUrl.label", { defaultValue: "Ссылка" })
          }
          variant="outlined"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton href={url} target="_blank" size="large">
                  <OpenInNewIcon />
                </IconButton>
                <IconButton onClick={() => handleCopy(url)} size="large">
                  <CopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};
